import { apiClient } from './client';

export async function previewCustomerTestCleanup(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/test-cleanup/preview`);
  return data.data;
}

export async function executeCustomerTestCleanup(customerId, confirmation) {
  const { data } = await apiClient.post(`/api/system/customers/${customerId}/test-cleanup`, {
    confirmation,
  });
  return data;
}
